import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";


class SpartaRequireUtility {
  constructor() {
    this.resourceLoadListeners = new Map();
    this._dynamicModulePromiseCache = new Map();
    this.deps = {};
    this.flattenedDeps = [];
  }

  get dynamicModulePromiseCache() {
    return this._dynamicModulePromiseCache;
  }

  set dynamicModulePromiseCache(moduleCache) {
    this._dynamicModulePromiseCache = moduleCache;
  }


  get dependencyList() {
    return this.deps;
  }






  registerResourceLoadListener(resourceUrl, callback) {
    this.resourceLoadListeners.set(resourceUrl, callback);
  }





  registerHandlerbarHelpers() {
    return new Promise((resolve, reject) => {
      if (this.helpersRegistered) {
        resolve();
      } else {
        this.getResourcesByWords('utilities/helpers')
          .then((utilities) => {
            utilities.forEach((util) => {
              if (util.register) {
                util.register(Handlebars);
              }
            });
            this.helpersRegistered = true;
            resolve();
          })
          .catch(reject);
      }
    });
  }





  resetHandlebarHelperFlag() {
    this.helpersRegistered = false;
  }





  unRegisterResourceLoadListener(resourceUrl) {
    this.resourceLoadListeners.delete(resourceUrl);
  }






  getRequirePromise(urls) {
    return new Promise((resolve, reject) => {
      this.getRequire()(urls, resolve, reject);
    });
  }













  getResourceWithDependencies(url) {
    let dynamicModulePromise = this._dynamicModulePromiseCache.get(url);
    if (dynamicModulePromise) {
      return dynamicModulePromise;
    }

    this.setOnResourceLoad(this.resourceLoadListeners);  

    dynamicModulePromise = new Promise(async (resolve, reject) => {
      try {
        this.registerResourceLoadListener(url, (context, map, depArray) => {
          if (url === map.id) {
            resolve({ context, map, depArray });
          }
        });
        const requireJs = this.getRequire();
        try {


          requireJs.s.contexts._.defined[url] && requireJs.undef(url);
        } catch (error) {
          console.log(`Error in requirejs.undef(${url})`, error);
        }
        await this.getRequirePromise([url]);
      } catch (error) {
        reject(error);
      } finally {
        this.unRegisterResourceLoadListener(url);
      }
    });
    this._dynamicModulePromiseCache.set(url, dynamicModulePromise);
    return dynamicModulePromise;
  }


  getRequire() {
    const widgetContext = spartaStoreUtility.getData('applicationContext');
    let requireJs;

    if (widgetContext) {
      const { name, version } = widgetContext;
      const widgetVersion = window.sparta.require[name][version];
      requireJs = (widgetContext.id) ? widgetVersion[widgetContext.id].require : widgetVersion.require;
    } else if (window.require) {
      requireJs = window.require;
    } else if (window.sparta && window.sparta.require) {
      requireJs = window.sparta.require;
      console.warn('fallback to window.sparta.require since window.require is undefined');
    } else {
      console.warn('requirejs is undefined');
    }

    this.deps = requireJs.dependenciesMap || {};

    return requireJs;
  }





  setOnResourceLoad(resourceLoadListeners) {
    const requireJs = this.getRequire();
    if (requireJs && !requireJs.onResourceLoad) {
      requireJs.onResourceLoad = function (context, map, depArray) {
        if (!requireJs.dependenciesMap) {
          requireJs.dependenciesMap = {};
        }
        depArray.forEach((dep) => {
          if (dep.id === 'exports') {
            return;
          }
          requireJs.dependenciesMap[map.id] = requireJs.dependenciesMap[map.id] || [];
          requireJs.dependenciesMap[map.id].push(dep.id);
        });
        const callback = map && map.id && resourceLoadListeners.get(map.id);
        callback && callback(context, map, depArray);
      };
    }
  }






  flattenDependencies() {
    const requireJS = this.getRequire();
    const dependencies = this.dependencyList;
    return Object.keys(dependencies).reduce((r, k) => {
      return [...new Set([...r, ...dependencies[k]])];
    }, []).sort();
  }







  getResourceByName(resourceName) {
    const path = this.filterResourcesByWords(resourceName)[0];
    return this.getRequirePromise([path]).then((resource) => new Promise((resolve, reject) => {
      if (!resource) return reject(new Error(`${module} is not in the page dependencies.`));
      return resolve(resource);
    })).catch((error) => error);
  }







  filterResourcesByWords(...words) {
    let deps = this.flattenedDeps;
    deps = (deps.length) ? deps : this.flattenDependencies();
    const ids = Object.keys(deps).filter((name) => words.every((word) => deps[name].includes(word)));
    return ids.map((id) => deps[id]);
  }







  getResourcesByWords(...words) {
    const paths = this.filterResourcesByWords(...words);
    return this.getResourcesByPaths(...paths);
  }







  getResourcesByPaths(...paths) {
    const promises = paths.map((path) => this.getRequirePromise([path]));
    return promises.reduce((promiseChain, currentTask) => { 
      return promiseChain.then((chainResults) =>
        currentTask.then((currentResult) => [...chainResults, currentResult]));
    }, Promise.resolve([]));
  }







  moduleDependencyList(module) {
    const depEntries = Object.entries(this.deps); 
    const modEntry = depEntries.filter((el) => el[0].endsWith(module));
    const modDeps = modEntry && modEntry[0][1];
    return modDeps;
  }
}

export default new SpartaRequireUtility();
